/** Keep a completed upload for a decision retry; a failed decision must not create another version. */
export function createResolutionUpload<T>() {
  let saved: { readonly file: File; readonly value: T } | null = null;
  let pending: { readonly file: File; readonly promise: Promise<T> } | null = null;
  return async (file: File, upload: () => Promise<T>): Promise<T> => {
    if (saved?.file === file) return saved.value;
    if (pending?.file === file) return pending.promise;
    const promise = upload().then((value) => {
      saved = { file, value };
      return value;
    });
    pending = { file, promise };
    try {
      return await promise;
    } finally {
      if (pending?.promise === promise) pending = null;
    }
  };
}
